import React from 'react';
import {makeStyles} from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import WhyComponent from "./whyComponent";
import PaperCustom from "../common/PaperCustom";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '100px 15%',
        [theme.breakpoints.only('xs')]: {
            padding: '50px 5%',
        },
    },
    paper: {
        padding: '50px 100px',
        [theme.breakpoints.only('xs')]: {
            padding: '25px 5%',
        },
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 50,
        [theme.breakpoints.down('sm')]: {
            marginBottom: 0
        },
    },
    title: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
        },
    },
    imgTitle: {
        marginRight: 20,
        [theme.breakpoints.down('sm')]: {
            width: 30,
        },
    },
    bar: {
        border: '1px solid #000000',
        flexGrow: 1,
        marginLeft: 20
    },
    barSmall: {
        border: '1px solid #000000',
        flexGrow: 1,
        marginBottom: 20,
        marginTop: 10,
        [theme.breakpoints.only('sm')]: {
            marginTop: 20,
        },
    },
    green: {
        color: "#94C11F"
    },
    subtitle1: {
        textTransform: 'uppercase',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            lineHeight: '20px',
        },
    },
    subtitle2: {
        [theme.breakpoints.down('sm')]: {
            fontSize: 14,
            lineHeight: '19px',
        },
    },
}));

const Why = React.forwardRef((props, ref) => {
    const classes = useStyles();

    return (
        <div className={classes.root} ref={ref}>
            <PaperCustom title={"POURQUOI CYKLAD ?"} src={'/image/why/whyPoint.png'} alt={"Logo point d'interrogation"}>
                <WhyComponent
                    imgSrc={'/image/why/worldIcon.png'}
                    title={<Typography variant={"subtitle1"} className={classes.subtitle1}>
                        Parce que <span className={classes.green}>la sécurité informatique doit pouvoir bénéficier à tous !</span>
                    </Typography>}
                    desc={<Typography variant={"subtitle2"} className={classes.subtitle2}>
                        Quel que soit la dimension de votre réseau et le nombre de vos utilisateurs, les enjeux demeurent
                        identiques.<br/><br/>Nous souhaitons partager notre passion et vous accompagner pour améliorer votre
                        protection et votre résilience vis-à-vis des menaces extérieures.<br/><br/>Nous ne croyons pas aux
                        solutions miracles et en revanche nous aimons tirer le meilleur des technologies que nous
                        utilisons.
                    </Typography>}
                />
                <WhyComponent
                    imgSrc={'/image/why/checkIcon.png'}
                    title={<Typography variant={"subtitle1"} className={classes.subtitle1}>
                        Parce que <span className={classes.green}>la qualité de service ne s’industrialise pas !</span>
                    </Typography>}
                    desc={<Typography variant={"subtitle2"} className={classes.subtitle2}>
                        Construite autour d’une relation de proximité entre vos ressources opérationnelles et nos
                        ingénieurs, c’est la promesse d’un suivi régulier, d’une réelle écoute de vos enjeux ainsi que
                        de vos contraintes métiers.
                        <br/><br/>
                        Nous travaillons avec vous pour valider les améliorations, identifier les freins et planifier les actions à mener.
                    </Typography>}
                />
                <WhyComponent
                    imgSrc={'/image/why/systemIcon.png'}
                    title={<Typography variant={"subtitle1"} className={classes.subtitle1}>
                        Parce que l’intégrité de votre système d’information repose sur <span className={classes.green}>3 fondamentaux incontournables :</span>
                    </Typography>}
                    desc={<Typography variant={"subtitle2"} className={classes.subtitle2}>
                        - la protection des postes utilisateurs et des ressources;<br/>
                        - le protection des flux réseaux;<br/>
                        - la sensibilisation des utilisateurs et l’accompagnement des décideurs.
                    </Typography>}
                />
            </PaperCustom>
        </div>
    )
});

export default Why